var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclaimBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 21,
    viewBox: "0 0 5 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2702 16.4551C1.01723 16.4551 0 17.4723 0 18.7258C0 19.9822 1.01723 21 2.2702 21C3.52516 21 4.54239 19.9827 4.54239 18.7258C4.54239 17.4723 3.52516 16.4551 2.2702 16.4551Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2702 0C1.01723 0 0 1.01723 0 2.2707C0 2.33798 0.0134561 2.39879 0.0184401 2.46258H0.00697753L0.913064 13.4637H0.920042C0.978853 14.161 1.55849 14.7137 2.2707 14.7137C2.9849 14.7137 3.56404 14.162 3.62285 13.4637H3.63033L4.53592 2.46258H4.52395C4.52993 2.39879 4.54239 2.33798 4.54239 2.2707C4.54239 1.01723 3.52516 0 2.2702 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimBadge);
export default __webpack_public_path__ + "static/media/exclaim-badge.bdd2b726.svg";
export { ForwardRef as ReactComponent };